export interface CreditsResponse {
  Credits: number,
  Breakdown: Record<string, number>;
  IsPending: boolean;
}
